import { SelectItem } from '../components/Form/types';

type KeyValueToSelectItemDataMapperReturn<T = string> = {
  dropdownList: SelectItem<T>[];
};

type KeyValueToSelectItemDataMapper<T = string, K = string> = {
  key: K;
  value: T;
}[];

/**
 * Maps key-value pairs to SelectItem data.
 *
 * @template T - The type of the value in the SelectItem.
 * @template K - The type of the key in the key-value pair.
 * @param {Object} params - The options object.
 * @param {KeyValueToSelectItemDataMapper<K, T>} params.data - The key-value pairs to be mapped.
 * @returns {KeyValueToSelectItemDataMapperReturn<T>} - The mapped SelectItem data.
 */
export const keyValueToSelectItemDataMapper = <T = string, K = string>({
  data,
}: {
  data: KeyValueToSelectItemDataMapper<K, T>;
}): KeyValueToSelectItemDataMapperReturn<T> => ({
  dropdownList: data.map(i => ({ label: i.value, value: i.key }) as unknown as SelectItem<T>),
});
